import axios from "axios";

const API_GO = process.env.REACT_APP_API_GO;

export const getHistoriesLookups = async (params) => {
	const { data } = await axios.get(`${API_GO}/app/history/lookups`, { params });
	return data;
};

export const getHistories = async (type, params) => {
	const endpointMap = {
		purchase: "/app/history/purchase",
		output: "/app/history/output",
		in_use: "/app/history/in_use",
		usage: "/app/history/usage",
		other_movements: "/app/history/other_movements",
		credit_notes: "/app/history/credit_notes",
		stolen: "/app/history/stolen",
	};

	const endpoint = endpointMap[type];
	if (!endpoint) {
		throw new Error(`Invalid history type: ${type}`);
	}

	const { data } = await axios.get(`${API_GO}${endpoint}`, { params });
	return data;
};

export const restoreInventory = async ({ inventoryId }) => {
	const { data } = await axios.post(`${API_GO}/app/inventory/restore`, { inventory_id: inventoryId });
	return data;
};

export const exportOutputPDF = async (applicationsIds) => {
	const response = await axios.get(`${API_GO}/app/history/io/export-pdf`, {
		params: { applications_ids: applicationsIds.join(",") },
		responseType: "blob",
	});
	return response;
};
